import React from 'react';
export function SocialProof() {
  const stats = [{
    value: '+2.000',
    label: 'padres y madres confían'
  }, {
    value: '11 Tomos',
    label: 'completamente listos'
  }, {
    value: '4.9/5 ⭐',
    label: 'calificación'
  }, {
    value: '🌍 Mundial',
    label: 'hispanohablante'
  }];
  return <section className="bg-cosmic-deep py-4 md:py-6 px-2 border-b border-white/10" data-id="element-298" data-mp="3bwra7onlrgxb">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-x-1 gap-y-3 md:gap-0 text-center" data-id="element-299" data-mp="3fn0u51d6i3x">
        {stats.map((s, i) => <div key={i} className={`flex flex-col items-center justify-center px-1 md:px-4 ${i < stats.length - 1 ? 'md:border-r md:border-white/10' : ''}`} data-id="element-300" data-mp="3pupj4ej5ml5f" data-mpi={i}>
            <div className="font-display font-black text-xl md:text-2xl text-white mb-0.5 leading-tight whitespace-nowrap" data-id="element-301" data-mp="mdzb5u40hy13">
              {s.value}
            </div>
            <div className="text-[11px] md:text-sm text-white/60 font-medium leading-tight whitespace-nowrap" data-id="element-302" data-mp="r5qsrf56wtf3">
              {s.label}
            </div>
          </div>)}
      </div>
    </section>;
}